export default __webpack_public_path__ + "static/media/CD__0002_0001.aad161e0.png";